import { UserContext } from '@/context/UserContext';
import { NotificationChannel } from '@/generated/zeus';
import { useUser } from '@stackframe/react';
import { useContext, useMemo } from 'react';

export default function useUserContext() {
  const user = useUser();
  const {location,position,token,config} = useContext(UserContext);

  const userData = useMemo(()=>{
    if(!user) return null;
    return {
      id: user.id,
      email: user.primaryEmail||"",
      displayName: user.displayName||"",
      phoneNumber:null,
      image: user.profileImageUrl||undefined,
      notificationPreference:{
        channels:[] as NotificationChannel[],
      }
    } 
  },[user]);
 
  return {
    config,
    token,
    location,
    position,
    user:user ? userData: undefined
  }
}

export function useFlags(){
  const context = useContext(UserContext);
  return {
    flags: context?.flags||undefined
  }
}
